const sliderItems=[
    {
        id:1,
        img:"https://freepngimg.com/thumb/grocery/41640-8-groceries-images-free-hd-image.png",
        title:"Upto 30% Off",
        desc:" Buy your favourite fresh fruits and Vegetables and get upto 30% off",
        color:"#badfe7",
        link:"/products"
    },
    {
        id:2,
        img:"https://freepngimg.com/save/53982-grocery-png-image-high-quality/700x450",
        title:"Packaged Food Items",
        desc:"Special Discounts on any packaged food item over rs. 500 and get 10% off",
        color:"#c2edce",
        link:"/products"
    },
    {
        id:3,
        img:"https://freepngimg.com/thumb/grocery/41619-7-groceries-free-download-image.png",
        title:"Fresh Dairy products Available",
        desc:"Get dairy products of your favourite kind. Fresh and local on your doorstep",
        color:"#f6f6f2",
        link:"/products"
    }
    ,
    {
        id:4,
        img:"https://www.pngmart.com/files/7/Delivery-PNG-Pic.png",
        title:"Free Delivery",
        desc:"Shop over Rs 1000 and get Free Delivery", 
        color:"#fafafb",
        link:"/products"
    }

];
const searchData = [
    {
      key: "john",
      value: "John Doe",
    },
    {
      key: "jane",
      value: "Jane Doe",
    },
    {
      key: "mary",
      value: "Mary Phillips",
    },
    {
      key: "robert",
      value: "Robert",
    },
    {
      key: "karius",
      value: "Karius",
    },
  ];
const categories=[
    {
        id:1,
        img:"https://www.pngall.com/wp-content/uploads/4/Grocery-PNG-Free-Download.png",
        cat:"Groceries"
    },
    {
        id:2,
        img:"https://i.pinimg.com/originals/7f/cc/d4/7fccd4143a51812cfbcff26451e2a113.png",
        cat:"Fruits and Vegetables"
    },
    {
        id:3,
        img:"https://www.pngkey.com/png/full/282-2822390_gallon-of-milk-png.png",
        cat:"Dairy Products"
    },
    {
        id:4,
        img:"https://cdn-icons-png.flaticon.com/512/2763/2763444.png",
        cat:"Beauty products"
    }
];
const popularProducts =[
    {
        id:1,
        img:"https://www.aashirvaad.com/img/nsfo/Atta.png",
    },
    {
        id:2,
        img:"http://www.gowardhanindia.com/images/product/1.png",
    },
    {
        id:3,
        img:"https://www.fortunefoods.com/wp-content/uploads/2022/12/01_0020_Biryani-Classic-1Kg-01-FOP_2.png",
    },
    {
        id:4,
        img:"https://www.kissan.in/sk-eu/content/dam/brands/kissan/india/2329670-kissan-fresh-tomato-500.png.rendition.767.767.png",
    },
    {
        id:5,
        img:"https://www.modernfoods.co.in/wp-content/uploads/2021/02/100-whole-wheat-rusk-productcategory-finalnew.png",
    },
    {
        id:6,
        img:"https://www.indiagatefoods.com/wp-content/uploads/2022/02/IG-Ecom-banners-1000x1000pix_Tibar_5kg_1.png",
    },
    {
        id:7,
        img:"https://www.modernfoods.co.in/wp-content/uploads/2021/02/multigrain-bread-modernfood-product-category.png",
    },
    {
        id:8,
        img:"https://www.modernfoods.co.in/wp-content/uploads/2021/02/cremeburst-berrypunch-product-category-newfinal.png",
    }
]
const Groceries=[
    {
        id:1,
        img:"",
        name:"",   
    },
    {
        id:1,
        img:"",
        name:"",   
    },
    {
        id:1,
        img:"",
        name:"",   
    },
    {
        id:1,
        img:"",
        name:"",   
    },
    {
        id:1,
        img:"",
        name:"",   
    },
]

export {categories,sliderItems,searchData,popularProducts};